import React, { useContext, useState, useEffect } from 'react';
import { styles } from '../../../config/defaultPageStyles';
import { list as listSameday, listRegular } from '../../../services/order';
import { getAccountInformation } from '../../../services/user';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../../../context/UserProvider';
import { toTitleCase, moneyFormat } from '../../../utils/helpers';
import { Button, Card, Grid, Typography } from '@mui/material';
import { status as sameDayStatus } from '../../../config/sameDayStatus';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import LoadingScreen from '../../../components/LoadingScreen';

let regularLabels = {
  door2door: 'Door 2 Door',
  dropoff2dropoff: 'Dropoff 2 Dropoff',
  dropoff2door: 'Dropoff 2 Door',
  door2dropoff: 'Door 2 Dropoff',
};

const App = () => {
  const { token, logout } = useContext(UserContext);
  const navigate = useNavigate();
  const [sameDayOrders, setSameDayOrders] = useState([]);
  const [regularOrders, setRegularOrders] = useState([]);
  const [regularOrdersForDelivery, setRegularOrdersForDelivery] = useState([]);

  const [vehicle, setVehicle] = useState(null);
  const [province, setProvince] = useState(null);
  const [loading, setLoading] = useState(true);
  const timeAgo = new TimeAgo('en-US');

  const loadSameDayOrders = () => {
    listSameday(token, {
      'driver-specific': true,
      'user-specific': false,
      'per-page': 'all',
    }).then(res => {
      setSameDayOrders(res.collection);
    });
  };

  const loadRegularOrders = () => {
    listRegular(token, {
      'driver-specific': 'origin-driver-id',
      'user-specific': false,
      'per-page': 'all',
    }).then(res => {
      setRegularOrders(res.collection);
    });
  };


  const loadRegularOrdersForDelivery = () => {
    listRegular(token, {
      'driver-specific': 'destination-driver-id',
      'user-specific': false,
      'per-page': 'all',
    }).then(res => {
      setRegularOrdersForDelivery(res.collection);
    });
  };

  const loadAccountInformation = () => {
    getAccountInformation(token).then(res => {
      setProvince(res?.driver['address-province'] ?? null);
      setVehicle(res?.vehicle?.type ?? null);
    });
  };

  useEffect(() => {
    loadAccountInformation();
  }, []);

  useEffect(() => {
    if (province) {
        loadOrders();
    }
  }, [province]);

  const loadOrders = () => {
    setLoading(true);
    loadSameDayOrders();
    loadRegularOrders();
    loadRegularOrdersForDelivery();
  }

  useEffect(() => {
    if (sameDayOrders && regularOrders) {
      setLoading(false);
    }
  }, [sameDayOrders, regularOrders]);

  const RenderOrders = () => {
    const renderSameDay = sameDayOrders.map((order, index) => {
      if (order.data.data.vehicle.id != vehicle) {
        return null;
      }

      return (
        <div
          key={`same-day-order-${index}`}
          style={{
            width: '100%',
            backgroundColor: '#F5F5F5',
            padding: '10px',
            marginBottom: '10px',
            borderRadius: '5px',
            border: 'solid 1px gainsboro',
          }}
          onClick={() => {
            navigate(`/driver/orders/sameday/${order.raw.id}`);
          }}>
          <Typography variant="body1">
            Same Day Delivery to {toTitleCase(order.data.data.receiver?.city ?? '')}
          </Typography>
          <Typography variant="body2">
            {order.data?.data['reference-number']}
          </Typography>
          <Typography variant="body1">
            Status:  {toTitleCase(order.data.status)}
          </Typography>
          <Typography variant="body2">
            Payment Type: {toTitleCase(order.data['payment-type'])}
          </Typography>
          <Typography variant="body2">
            Total: PHP {moneyFormat(order.data.total)}
          </Typography>
          <Typography variant="body2">
            {timeAgo.format(new Date(order.raw.created_last))}
          </Typography>
        </div>
      );
    });

    const renderRegular = regularOrders.map((order, index) => {
      return (
        <div
          key={`same-day-order-${index}`}
          style={{
            width: '100%',
            backgroundColor: '#F5F5F5',
            padding: '10px',
            marginBottom: '10px',
            borderRadius: '5px',
            border: 'solid 1px gainsboro',
          }}
          onClick={() => {
            navigate(`/driver/orders/regular/${order.raw.id}`);
          }}>
          <Typography variant="body1">
            Regular Delivery to {toTitleCase(order.data.data.receiver?.city  ?? '')}
          </Typography>
          <Typography variant="body2">
            {order.data?.data['reference-number']}
          </Typography>
          <Typography variant="body1">
            Status:  {order.data.status == 'driver matched' ? 'For Pickup' : toTitleCase(order.data.status)}
          </Typography>
          <Typography variant="body2">
            Payment Type: {toTitleCase(order.data['payment-type'])}
          </Typography>
          <Typography variant="body2">
            Total: PHP {moneyFormat(order.data.total)}
          </Typography>
          <Typography variant="body2">
            {timeAgo.format(new Date(order.raw.created_last))}
          </Typography>
        </div>
      );
    });


    const renderRegularForDelivery = regularOrdersForDelivery.map((order, index) => {
      return (
        <div
          key={`same-day-order-${index}`}
          style={{
            width: '100%',
            backgroundColor: '#F5F5F5',
            padding: '10px',
            marginBottom: '10px',
            borderRadius: '5px',
            border: 'solid 1px gainsboro',
          }}
          onClick={() => {
            navigate(`/driver/orders/regular/${order.raw.id}`);
          }}>
          <Typography variant="body1">
            Regular Delivery to {toTitleCase(order.data.data.receiver?.city ?? '')}
          </Typography>
          <Typography variant="body2">
            {order.data?.data['reference-number']}
          </Typography>
          <Typography variant="body1">
            Status:  {order.data.status == 'driver matched' ? 'For Pickup' : toTitleCase(order.data.status)}
          </Typography>
          <Typography variant="body2">
            Payment Type: {toTitleCase(order.data['payment-type'])}
          </Typography>
          <Typography variant="body2">
            Total: PHP {moneyFormat(order.data.total)}
          </Typography>
          <Typography variant="body2">
            {timeAgo.format(new Date(order.raw.created_last))}
          </Typography>
        </div>
      );
    });

    if (sameDayOrders.length === 0 && regularOrders.length === 0 && renderRegularForDelivery.length === 0) {
      return (
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            fontSize: '1.2rem',
            paddingTop: '15px',
            paddingBottom: '15px',
          }}>
          No orders yet
        </div>
      );
    }

    return (
      <>
        {renderSameDay}
        {renderRegular}
        {renderRegularForDelivery}
      </>
    );
  };

  return (
    <div style={styles.pageContainer}>
        {loading && <LoadingScreen />}
      <div style={styles.pageHeader}>Orders History</div>
      <RenderOrders />
      <Button
        onClick={() => navigate('/driver')}
        variant="contained"
        fullWidth
        style={{ marginTop: '10px' }}>
        Back
      </Button>
    </div>
  );
};

export default App;
